import { useAuth } from '@clerk/clerk-react';

/**
 * Checks if the current user is being impersonated by another user
 *
 * @see https://clerk.com/docs/users/user-impersonation#detect-impersonated-sessions-in-the-frontend
 * @returns true if the current user is impersonated, false otherwise
 */
export const useIsImpersonatedUser = () => {
  const { actor } = useAuth();
  return !!actor?.sub;
};
